import { render, staticRenderFns } from "./fillLogisticsInfo.vue?vue&type=template&id=2286e9db&scoped=true&"
import script from "./fillLogisticsInfo.vue?vue&type=script&lang=js&"
export * from "./fillLogisticsInfo.vue?vue&type=script&lang=js&"
import style0 from "./fillLogisticsInfo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./fillLogisticsInfo.vue?vue&type=style&index=1&id=2286e9db&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2286e9db",
  null
  
)

export default component.exports